import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { Input } from '@cotera/client/v0/components/ui/input';
import { Button } from '@cotera/client/v0/components/ui/button';
import { cn } from '@cotera/client/v0/lib/utils';

/**
 * Masked field for a provider secret. Signing secrets are often pasted with a
 * screen shared, so the value stays hidden by default — but a paste is
 * impossible to sanity-check while masked, hence the reveal toggle. Drop-in for
 * `Input`: `className` lands on the input so callers keep their own styling.
 */
export const SecretInput: React.FC<{
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}> = ({ value, onChange, placeholder, className }) => {
  const [revealed, setRevealed] = useState(false);

  return (
    <div className="relative w-full">
      <Input
        type={revealed ? 'text' : 'password'}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder={placeholder}
        autoComplete="off"
        spellCheck={false}
        className={cn('pr-10', className)}
      />
      <Button
        type="button"
        variant="ghost"
        size="icon-sm"
        className="absolute right-1 top-1/2 -translate-y-1/2 text-muted-foreground"
        aria-label={revealed ? 'Hide secret' : 'Reveal secret'}
        aria-pressed={revealed}
        onClick={() => setRevealed((current) => !current)}
      >
        {revealed ? (
          <EyeOff className="h-4 w-4" />
        ) : (
          <Eye className="h-4 w-4" />
        )}
      </Button>
    </div>
  );
};
